/**
 * Default: layout > Menu
 */

import {
	lockBodyScrolling,
	unlockBodyScrolling
} from '@ifabnpm/bootstrap/utils/scroll.js';

import SelectorEngine from '@ifabnpm/bootstrap/dom/selector-engine.js';
import Manipulator from '@ifabnpm/bootstrap/dom/manipulator.js';
import EventHandler from '@ifabnpm/bootstrap/dom/event-handler.js';

import Nav from '@ifabnpm/bootstrap/component/nav.js';
import Drawer from '@ifabnpm/bootstrap/component/drawer.js';

// -------
// Private
// -------

const NAME      = 'menu';
const DATA_KEY  = `ifab.${NAME}`;
const EVENT_KEY = `.${DATA_KEY}`;
// const API_KEY    = '.data-api';

let pageMenu;
let pageMenuTrigger;
let mainNavInstance;

/**
 * Drawer (Navigationsoverlay)
 */
const setupDrawer = () => {
	const drawer  = new Drawer(pageMenu, {
		closeButton: false,
		// closeIcon : `<svg aria-hidden="true" preserveAspectRatio="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
		// 	<path d="M 3.52,4.59 C 3.63,4.53 3.74,4.47 3.85,4.4 4.43,4.79 4.84,5.42 5.34,5.94 6.16,6.8 7.03,7.31 8.1,7.84 c 1.56,0.78 3.12,1.28 4.29,2.6 0.68,0.77 1.37,1.52 2.05,2.28 0.69,0.77 1.14,1.6 1.62,2.31 0.51,0.77 1.17,1.36 1.48,2.29 0.26,0.78 0,1.9 0.81,2.39" style="fill:none;fill-opacity:1;stroke:var(--svg-color, #21201c);stroke-opacity:1;stroke-width:var(--svg-border-width, 1.7);stroke-dasharray:none;"></path>
		// 	<path d="M 2.95,19.46 C 5.79,17.08 8.63,14.69 11.47,12.31 12.86,11.14 14.13,9.87 15.31,8.52 15.86,7.89 16.07,7.33 16.76,6.71 17.6,5.96 18.32,5.46 18.81,4.4" style="fill:none;fill-opacity:1;stroke:var(--svg-color, #21201c);stroke-opacity:1;stroke-width:var(--svg-border-width, 1.7);stroke-dasharray:none;"></path>
		// </svg>`,
		// onInit   : (event) => {
		// 	const componentCloseButton = SelectorEngine.findOne('.drawer__header > .drawer-close', event.target);
		//
		// 	if (componentCloseButton) {
		// 		componentCloseButton.remove();
		// 	}
		// },
		onShow   : function() {
			if (pageMenuTrigger) {
				EventHandler.trigger(pageMenuTrigger, `on${DATA_KEY}`);
			}
		},
		onHidden : () => {
			if (pageMenuTrigger) {
				EventHandler.trigger(pageMenuTrigger, `off${DATA_KEY}`);
			}
		}
	});

	if (pageMenuTrigger) {
		EventHandler.on(pageMenuTrigger, `on${DATA_KEY}`, (event) => {
			event.preventDefault();
			event.stopPropagation();

			event.target.setAttribute('aria-pressed', 'true');
		});

		// Trigger-Event: Menütrigger inaktiv
		EventHandler.on(pageMenuTrigger, `off${DATA_KEY}`, (event) => {
			event.preventDefault();
			event.stopPropagation();

			event.target.removeAttribute('aria-pressed', 'false');
		});

		EventHandler.on(pageMenuTrigger, 'click', (event) => {
			event.preventDefault();
			event.stopPropagation();

			if (event.target.getAttribute('aria-pressed') === 'true') {
				drawer.hide();
			} else {
				drawer.show();
			}
		});
	}
};

/**
 * Initialisierung der eigentlichen Navigationsliste.
 */
const navigation = () => {
	const nav = SelectorEngine.findOne('#main-nav');

	if (nav) {
		mainNavInstance = new Nav(nav, {
			closeByOutsideClick: false,
			closeByEsc         : false,
			labelSubmenu       : (window.pageInstance.tm) ? window.pageInstance.tm.translate('ariaLabelSubmenu') : 'Submenu for %s',
			labelSubmenuTrigger: (window.pageInstance.tm) ? window.pageInstance.tm.translate('ariaLabelSubmenuTrigger') : 'Show submenu for %s',
			useReveal          : true, // { visibleDisplay: 'flex' },
			onHide             : () => {
				// Manipulator.addClass(event.relatedMenu, '-will-hide');
			},
			onHidden           : () => {
				// Manipulator.removeClass(event.relatedMenu, '-will-hide');
			},
			onShow             : () => {
				// Manipulator.addClass(event.relatedMenu, '-will-show');
			},
			onShown            : () => {
				// Manipulator.removeClass(event.relatedMenu, '-will-show');
			}
		});

		mainNavInstance.showCurrentTree();

		// const curPageItem = SelectorEngine.findOne('[aria-current="page"]');
		//
		// if (appMenuBody && curPageItem) {
		// 	scrollElementIntoView(curPageItem, appMenuBody, 'vertical');
		// }
	}
};

// -------
// Public
// -------

const menu = () => {
	pageMenu = SelectorEngine.findOne('#page-menu-drawer');
	pageMenuTrigger = SelectorEngine.findOne('[aria-controls="page-menu-drawer"]')

	if (pageMenu) {
		setupDrawer();
		navigation();
	}
};

// Export
export default menu;
